import {
  View,
} from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import { usePersonalStore } from '../../../stores/personalInfo'
import moment from 'moment'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import { useTranslation } from 'react-i18next'
import AsyncStorage from '@react-native-async-storage/async-storage'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SignatureFormView from '../SignatureFormView'

const I9informationonline = ({ navigation, route }: any) => {
  const {
    userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    values
  } = route.params
  const personalstore = usePersonalStore()
  const initializestore = useInitializeStore()
  const { posti9details, loading } = useFormsStore()
  const { t } = useTranslation()
  const getLanguage = async () => {
    try {
      const language = await AsyncStorage.getItem('selectedLanguage') || 'ENG';
      if (language === 'SPA') {
        return 'Spanish';
      } else {
        return 'English';
      }
    } catch (error) {
      console.error('Error retrieving selected language:', error);
      return 'English';
    }
  }



  const handlesubmit = async (signatureDataURL: string) => {
    const data = {
      essUserKey: initializestore.initializeData?.userkey,
      formKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      entityId: personalstore.personalData?.entityId,
      citizenship: values?.citizenship?.toString(),
      aNumber: values?.uscisNumber ? "A" + values?.uscisNumber : "",
      i94Number: values?.i94Number,
      passportNumber: values?.passportNumber,
      passportCountry: values?.passportCountry,
      expiryDate: values?.expirydate
        ? moment(values.expirydate).format('YYYY-MM-DD')
        : null,
      completeOnline: mode === 'upload' ? false : true,
      language: await getLanguage(),
      sign: signatureDataURL
    }
    const response = await posti9details(data)
    if (response?.success === true) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: t(response?.message),
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: t(response?.message),
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel={t('Forms')}
            navScreen="OnboardingForms"
            title={t('I-9 Information')}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('I9InformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",

          })
        }
        onSubmit={handlesubmit}
        previousText={t("Previous")}
        submitText={t("Submit")}
        stateValue="I9"
      />
    </>
  )
}

export default I9informationonline
